import { WebFsError } from '#common/types';
import { ConfigUnavailableError } from '#config/types';
export class DataStoresError extends WebFsError {
}
export class DataStoreNotFoundError extends DataStoresError {
}
export class DataStoreAlreadyExistsError extends DataStoresError {
}
export class DataStoreLimitExceededError extends DataStoresError {
}
export class DataStoreHasLinkedFilesError extends DataStoresError {
}
export class DataStoreInvalidBucketNameError extends DataStoresError {
}
export class DataStoreInvalidRegionError extends DataStoresError {
}
export class DataStoreInvalidCredentialsError extends DataStoresError {
}
export class DataStoreInvalidTypeError extends DataStoresError {
}
export class DataStoreNotProvidedError extends DataStoresError {
}
export class DataStoresUnavailableError extends ConfigUnavailableError {
}
export class DataStoresNotSupportedError extends DataStoresUnavailableError {
}
export class DataStoresNotConfiguredError extends DataStoresUnavailableError {
}
export class ExternalFilesUnavailableError extends ConfigUnavailableError {
}
export class ExternalFilesNotSupportedError extends ExternalFilesUnavailableError {
}
export class ExternalFilesNotConfiguredError extends ExternalFilesUnavailableError {
}
export class ExternalFilesDisabledError extends ExternalFilesUnavailableError {
}
export class HttpFileValidationError extends WebFsError {
}
export class HttpFileUnreachableError extends HttpFileValidationError {
}
